import { ROUTES } from 'routes/constants';
import { armClickShield, isFromAppClient } from './armClickShield';

/** Landing di vendita Premium (non la pagina Fatturazione). */
export const PREMIUM_UPGRADE_PATH = `${ROUTES.SETTINGS}${ROUTES.PREMIUM}`;

/** Fatturazione / gestione abbonamento. */
export const BILLING_PATH = `${ROUTES.SETTINGS}${ROUTES.PAYMENTS}`;

const isPremiumPath = (pathname = '') =>
  pathname === PREMIUM_UPGRADE_PATH || pathname.startsWith(`${PREMIUM_UPGRADE_PATH}/`);

const isBillingPath = (pathname = '') =>
  pathname === BILLING_PATH || pathname.startsWith(`${BILLING_PATH}/`);

/** Finestra in cui i tap fantasma non devono aprire Fatturazione. */
let billingNavBlockUntil = 0;

export const armBillingNavigationBlock = (ms) => {
  billingNavBlockUntil = Math.max(billingNavBlockUntil, Date.now() + ms);
};

/** @internal test helper */
export const clearBillingNavigationBlock = () => {
  billingNavBlockUntil = 0;
};

export const isBillingNavigationBlocked = () => Date.now() < billingNavBlockUntil;

/**
 * true se la navigazione verso Fatturazione va ignorata (ghost dopo "Passa a Premium").
 * I click espliciti dopo la finestra passano.
 */
export const shouldBlockBillingNavigation = (to) => {
  if (!isBillingNavigationBlocked()) return false;
  const path = typeof to === 'string' ? to.split('?')[0] : to?.pathname || '';
  return isBillingPath(path);
};

const closeUiAfterNavigate = (onAfterNavigate, delayMs) => {
  if (!onAfterNavigate) return;
  window.requestAnimationFrame(() => {
    window.setTimeout(() => onAfterNavigate(), delayMs);
  });
};

/**
 * Vai alla landing Premium. Blocca il tap fantasma da telefono che altrimenti
 * colpisce Fatturazione (o altra riga) sotto il modal/dropdown appena chiuso.
 *
 * Ordine: shield → navigate (la landing monta sotto) → poi chiudere UI.
 * Chiudere prima espone Impostazioni/Home al click fantasma.
 */
export const goToPremiumUpgrade = (navigate, { onAfterNavigate } = {}) => {
  const inApp = isFromAppClient();
  armClickShield(inApp ? 1200 : 700);
  // Blocca anche navigate()/link verso Fatturazione se il ghost bypassa lo shield.
  armBillingNavigationBlock(inApp ? 1600 : 900);
  navigate(PREMIUM_UPGRADE_PATH);
  closeUiAfterNavigate(onAfterNavigate, inApp ? 320 : 180);
};

export const goToBilling = (navigate, { onAfterNavigate } = {}) => {
  if (shouldBlockBillingNavigation(BILLING_PATH)) {
    // Ghost dopo upgrade: resta / riporta sulla landing Premium.
    if (!isPremiumPath(window.location?.pathname || '')) {
      navigate(PREMIUM_UPGRADE_PATH);
    }
    return;
  }
  armClickShield();
  navigate(BILLING_PATH);
  closeUiAfterNavigate(onAfterNavigate, 180);
};

export { isPremiumPath, isBillingPath };
